<template>
  <div class="registration">
    <h1>Rejestracja</h1>
    <form>
      <NameAuthInput />
      <LoginAuthInput />
      <EmailAuthInput />
      <PasswordAuthInput />
      <RepeatPasswordAuthInput />
      <LicenseAgreementCheckbox />
    </form>
    <p v-if="unknownError" class="error">
      Wystąpił nieznany błąd. Prosimy skontaktować się z naszą pomocą techniczną pod adresem
      biuro@followup.social</p>
    <p v-if="connectionError" class="error">Nie udało połączyć się z serwerem.
      Prosimy sprawdzić stan połączenia sieciowego.</p>
    <button :class="{ 'btn-grayed': !allValid }"
    @click.prevent="register">Zarejestruj się</button>
    <button @click="proceedToLoginForm" class="btn-gray btn-small">wróć</button>
  </div>
</template>

<script>
import NameAuthInput from '@/components/authentication/inputs/registration/NameAuthInput.vue';
import LoginAuthInput from '@/components/authentication/inputs/registration/LoginAuthInput.vue';
import EmailAuthInput from '@/components/authentication/inputs/registration/EmailAuthInput.vue';
import PasswordAuthInput from '@/components/authentication/inputs/registration/PasswordAuthInput.vue';
import RepeatPasswordAuthInput from '@/components/authentication/inputs/registration/RepeatPasswordAuthInput.vue';
import LicenseAgreementCheckbox from '@/components/authentication/inputs/registration/LicenseAgreementCheckbox.vue';

export default {
  name: 'RegistrationForm',
  components: {
    NameAuthInput,
    LoginAuthInput,
    EmailAuthInput,
    PasswordAuthInput,
    RepeatPasswordAuthInput,
    LicenseAgreementCheckbox
  },
  computed: {
    allValid() {
      return this.$store.getters.allRegistrationFieldsValid;
    },
    connectionError() {
      return this.$store.getters.connectionAuthError;
    },
    unknownError() {
      return this.$store.getters.unknownAuthError;
    }
  },
  methods: {
    register() {
      if (!this.allValid) return;

      this.$store.dispatch('clearAllAuthErrors');
      this.$store.commit('setLoadingMessage', 'Trwa rejestracja...');
      this.$store.commit('setLoading', true);

      this.$store.dispatch('register')
        .then(() => {
          this.$store.dispatch('fillLoginWithRegistrationDetails');
          this.$store.dispatch('login');
        })
        .catch(() => {
          this.$store.commit('setLoadingMessage', '');
          this.$store.commit('setLoading', false);
        });
    },
    proceedToLoginForm() {
      this.$store.commit('proceedToLoginForm');
    }
  }
};
</script>
